import { css } from '@emotion/css';

export const loaderContainerStyles = css`
  height: 28.4rem;
`;
